import { render, staticRenderFns } from "./ProfileAccount.vue?vue&type=template&id=888b09d0&scoped=true"
import script from "./ProfileAccount.vue?vue&type=script&lang=js"
export * from "./ProfileAccount.vue?vue&type=script&lang=js"
import style0 from "./ProfileAccount.vue?vue&type=style&index=0&id=888b09d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888b09d0",
  null
  
)

export default component.exports